import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {AuthAppService} from "sign-up-app/services/auth.service";
import {Router} from "@angular/router";
import {ResetPasswordState} from "sharedGuiSmall/enums/resetPasswordState";

@Component({
    selector: 'reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.less']
})
export class ResetPasswordComponent implements OnInit {

    @ViewChild('passwordInput')
    private passwordInput!: ElementRef<HTMLInputElement>;

    @ViewChild('passwordWrongMsg')
    private passwordWrongMsg!: ElementRef<HTMLDivElement>;

    @ViewChild('passwordConfirmInput')
    private passwordConfirmInput!: ElementRef<HTMLInputElement>;

    @ViewChild('passwordConfirmWrongMsg')
    private passwordConfirmWrongMsg!: ElementRef<HTMLDivElement>;

    @ViewChild('pwdHints')
    private pwdHints!: ElementRef<HTMLDivElement>;

    fullLiveUrl = window.fullLiveUrl;
    password: string = '';
    passwordConfirm: string = '';
    isPasswordValid: boolean = false;
    isPasswordConfirmValid: boolean = false;
    topMargin: number = 55;

    resetPasswordState = ResetPasswordState;
    passwordState: ResetPasswordState = ResetPasswordState.NewPassword;
    successPassChangeTxt: string = "PASSWORD_CHANGED_SUCCESSFULLY";
    failedPassChangeTxt: string = "THIS_RESET_PASSWORD_FORM";

    resetPasswordButtonText = $localize`RESET_PASSWORD`;
    signInButtonText = $localize`sign_in`;
    constructor(
        private router: Router,
        private authService: AuthAppService,
        private el: ElementRef
    ) {

    }

    ngOnInit(): void {
        this.checkResetPasswordError();
    }

    checkResetPasswordError(): void{
        const code = window.location.href.split('=')[1];
        this.authService.checkResetPasswordError(code).then(isResetPasswordExpired => {
            if(isResetPasswordExpired){
                console.warn('resetPasswordExpired', "true");
                this.passwordState = ResetPasswordState.ResetPasswordExpired;
                this.topMargin = 130;
            }
        });
    }

    goToSignIn(): void {
        window.location.href = this.fullLiveUrl+'sign-in';
        //this.router.navigate(['signIn'], { replaceUrl: true });
    }

    goToForgottenPassword(): void {
        //window.location.href = this.fullLiveUrl+'signIn';
        window.location.href = this.fullLiveUrl+'forgotten-password';
        //this.router.navigate(['forgottenPassword'], { replaceUrl: true });
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.key == "Enter")
            this.resetPassword();
    }

    onPasswordType() {
        this.authService.ProcessPasswordHints(this.password, this.pwdHints, 8);
    }

    validatePassword(): void {
        this.isPasswordValid = this.authService.ValidateField(this.passwordInput, this.passwordWrongMsg, this.password, ['required','minlength 8','uppercase','lowercase','special','maxlength 48'],
            {'required': 'The Password field must be completed', 'minlength': 'Minimum password length 8 characters', 'uppercase': 'Does not meet password requirements',
                'lowercase': 'Does not meet password requirements', 'special': 'Does not meet password requirements',
                'maxlength': 'Maximum password length 48 characters'});
    }

    validateConfirmPassword(): void {
        this.isPasswordConfirmValid = this.authService.ValidateField(this.passwordConfirmInput, this.passwordConfirmWrongMsg, this.password, ['confirmpassword'],
            {'confirmpassword': 'Passwords does not match'}, this.passwordConfirm);
    }

    resetPassword(): void {

        this.validatePassword();
        this.validateConfirmPassword();

        if (this.isPasswordValid && this.isPasswordConfirmValid) {
            //todo use router params
            const code = window.location.href.split('=')[1];
            console.warn('code', code);
            const data = JSON.stringify({ 'password': this.password, 'resetCode': code });

            this.authService.PasswordReset(data).then((res: string) => {
                console.warn('PasswordReset ', res);
                this.passwordState = ResetPasswordState.PasswordChanged;
                this.topMargin = 130;
            });
        }

    }

}
